export default __webpack_public_path__ + "static/media/ari.98769cc5.png";